let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3kpP9")).then(() => parcelRequire('ik2mQ'));